module.exports = __webpack_public_path__ + "/images/logo-af-buybuy-baby.96dd56c.png";